import { __awaiter, __generator } from "tslib";
var TransactionContext = /** @class */ (function () {
    function TransactionContext(_a) {
        var keepActive = _a.keepActive, comparer = _a.comparer, channelDB = _a.channelDB, channelModel = _a.channelModel, channelLazyMigration = _a.channelLazyMigration;
        this.keepActive = keepActive;
        this.comparer = comparer;
        this.channelDB = channelDB;
        this.channelModel = channelModel;
        this.channelLazyMigration = channelLazyMigration;
    }
    TransactionContext.fromTransactionManager = function (manager, keepActive) {
        if (keepActive === void 0) { keepActive = false; }
        return new TransactionContext({
            keepActive: keepActive,
            comparer: manager.comparer,
            channelDB: manager.channelDB,
            channelModel: manager.channelModel,
            channelLazyMigration: manager.channelLazyMigration,
        });
    };
    TransactionContext.prototype.prepareDBForTransaction = function (tableNames, mode) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.transactionPreparePromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var db;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, Promise.all(tableNames.map(function (name) { return _this.waitForModelRegistered(name); }))];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, Promise.all(tableNames.map(function (name) { return _this.waitForMigrationReady(name); }))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, this.waitForDBReady()];
                            case 3:
                                db = _a.sent();
                                return [2 /*return*/, {
                                        startTransaction: function () {
                                            if (_this.transaction) {
                                                return _this.transaction;
                                            }
                                            _this.transaction = db.transaction(tableNames, mode);
                                            return _this.transaction;
                                        },
                                    }];
                        }
                    });
                }); })();
                return [2 /*return*/, this.transactionPreparePromise];
            });
        });
    };
    TransactionContext.prototype.getTransactionGenerator = function (tableNames, mode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.transactionPreparePromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.prepareDBForTransaction(tableNames, mode)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.transactionPreparePromise];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TransactionContext.prototype.waitForDBReady = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channelDB.pick()];
            });
        });
    };
    TransactionContext.prototype.waitForModelRegistered = function (collectionName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channelModel.pick(collectionName)];
            });
        });
    };
    TransactionContext.prototype.waitForMigrationReady = function (collectionName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channelLazyMigration.pick(collectionName)];
            });
        });
    };
    TransactionContext.prototype.perform = function (fn) {
        if (this.keepActive) {
            return fn();
        }
        return this.autoCommitOrRollback(fn);
    };
    TransactionContext.prototype.autoCommitOrRollback = function (fn) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 5]);
                        return [4 /*yield*/, fn()];
                    case 1:
                        data = _c.sent();
                        return [4 /*yield*/, ((_a = this.transaction) === null || _a === void 0 ? void 0 : _a.commit())];
                    case 2:
                        _c.sent();
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _c.sent();
                        return [4 /*yield*/, ((_b = this.transaction) === null || _b === void 0 ? void 0 : _b.rollback())];
                    case 4:
                        _c.sent();
                        throw err_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return TransactionContext;
}());
export default TransactionContext;
//# sourceMappingURL=transaction-context.js.map